/**
 * Customer Reviews - Pagination and filtering
 */
const REVIEW_TRUNCATE_LENGTH = 200;

function smoothScrollTo(startY, targetY, duration) {
    const diff = targetY - startY;
    let startTime = null;

    function step(timestamp) {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const ease = progress < 0.5
            ? 2 * progress * progress
            : -1 + (4 - 2 * progress) * progress;
        document.body.scrollTo(0, startY + diff * ease);
        if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mod24eFeedback2').forEach(initReviewsComponent);
});

function initToggleMore(container) {
    container.querySelectorAll('.js24Text').forEach(p => {
        p.addEventListener('click', e => {
            const btn = e.target.closest('.js24ToggleMore');
            if (!btn) return;
            const short = p.querySelector('.inl24Text__short');
            const full = p.querySelector('.inl24Text__full');
            if (!short || !full) return;
            const isExpanded = !full.hidden;
            short.hidden = !isExpanded;
            full.hidden = isExpanded;
        });
    });
}

function initReviewsComponent(container) {
    const { provider, animal } = container.dataset;
    const template = container.querySelector('.js24ReviewTemplate');

    if (!provider || !animal || !template) return;

    initToggleMore(container);

    const commentsEl = container.querySelector('.box24Comments');
    const paginationEl = container.querySelector('.js24ReviewsPagination');
    const filterItems = container.querySelectorAll('.js24Filter');
    let currentFilter = null;

    // Filter handlers
    filterItems.forEach(item => {
        item.addEventListener('click', () => {
            const stars = parseInt(item.dataset.stars, 10) || null;
            currentFilter = (currentFilter === stars && stars !== null) ? null : stars;

            // Update selected state
            filterItems.forEach(el => el.classList.remove('selected'));
            const selected = currentFilter === null
                ? [...filterItems].find(el => !parseInt(el.dataset.stars, 10))
                : [...filterItems].find(el => parseInt(el.dataset.stars, 10) === currentFilter);
            selected?.classList.add('selected');

            fetchComments(1, true);
        });
    });

    // Initial pagination handlers
    if (paginationEl) {
        paginationEl.addEventListener('click', handlePaginationClick);
    }

    function handlePaginationClick(e) {
        const pageItem = e.target.closest('.js24Page');
        if (pageItem && !pageItem.classList.contains('c24Selected')) {
            fetchComments(parseInt(pageItem.dataset.page, 10), true);
        }
    }

    function fetchComments(page, scrollToTop = false) {
        const params = new URLSearchParams({ provider, animal, page });
        if (currentFilter) params.set('star', currentFilter);

        commentsEl.classList.add('loading');

        fetch(`/katzenversicherung/api/efeedback/comments?${params}`)
            .then(res => res.ok ? res.json() : Promise.reject('Network error'))
            .then(data => {
                renderComments(data.comments);
                renderPagination(data.pagination);
                commentsEl.classList.remove('loading');
                if (scrollToTop && window.innerWidth < 768) {
                    const feedbackCommentsCard = container.querySelector('.feedback-comments');
                    if (feedbackCommentsCard) {
                        const startY = document.body.scrollTop;
                        const targetY = startY + feedbackCommentsCard.getBoundingClientRect().top;
                        smoothScrollTo(startY, targetY, 400);
                    }
                }
            })
            .catch(err => {
                console.error('Error fetching comments:', err);
                commentsEl.classList.remove('loading');
            });
    }

    function renderComments(comments) {
        if (!comments.length) {
            commentsEl.innerHTML = '<li class="box24Comment"><p class="inl24Text">Keine Bewertungen gefunden.</p></li>';
            return;
        }

        commentsEl.innerHTML = '';
        comments.forEach((comment, i) => {
            const clone = template.content.cloneNode(true);
            const li = clone.querySelector('li');

            clone.querySelector('.js24StarsFilled').style.width = `${(comment.rating / 5) * 100}%`;
            clone.querySelector('.js24Name').textContent = comment.name;
            clone.querySelector('.js24Type').textContent = 'Antragsbearbeitung';
            clone.querySelector('.js24Date').textContent = comment.received;

            const textEl = clone.querySelector('.js24Text');
            if (comment.comment.length > REVIEW_TRUNCATE_LENGTH) {
                textEl.innerHTML = `<span class="inl24Text__short">${comment.comment.slice(0, REVIEW_TRUNCATE_LENGTH)}&hellip; <button class="js24ToggleMore inl24Text__toggle" type="button">Mehr anzeigen</button></span><span class="inl24Text__full" hidden>${comment.comment} <button class="js24ToggleMore inl24Text__toggle" type="button">Weniger anzeigen</button></span>`;
            } else {
                textEl.textContent = comment.comment;
            }

            li?.classList.add(i % 2 === 0 ? 'odd' : 'even');
            if (i === comments.length - 1) li?.classList.add('c24Last');

            commentsEl.appendChild(clone);
        });
        initToggleMore(commentsEl);
    }

    function renderPagination(data) {
        if (!paginationEl) return;

        paginationEl.innerHTML = Array.from({ length: data.totalPages }, (_, i) => {
            const page = i + 1;
            const selected = page === data.currentPage ? ' c24Selected' : '';
            return `<li class="js24Page${selected}" data-page="${page}">${page}</li>`;
        }).join('');
    }
}
